import { useNavigate } from "react-router-dom"
import { Emitter, Event } from "../../../../features/event-emitter"
import { ModalId, showToast, useUIActions } from "../../../../features/ui"
import { useStockService } from "../../services/stockService"

export const useActions = () => {
    const navigate = useNavigate()

    const { transformStock } = useStockService()

    const { closeModal } = useUIActions()

    const submitTransformStock = async (
        sourceProductId: string,
        destinationProductId: string,
        branchId: string,
        sourceQty: number,
        destinationQty: number,
        destinationLotId?: string
    ) => {
        Emitter.emit(Event.DB_SUBMIT)
        
        await transformStock(sourceProductId, destinationProductId, branchId, sourceQty, destinationQty, destinationLotId)

        setTimeout(() => {
            closeModal(ModalId.SPINNER)
            showToast('La transformación de stock fue completada.')
            navigate(-1)
        }, 1000)
    }
    
    return {
        submitTransformStock
    }
}
